module.exports = __webpack_public_path__ + "img/mascot.ad4c1960.png";